import { cn } from "~/lib/utils";

export function BrandMark({
  size = 28,
  withWordmark = false,
  className,
}: {
  size?: number;
  withWordmark?: boolean;
  className?: string;
}) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <img
        className="brand-glyph"
        src={`${import.meta.env.BASE_URL}brand-glyph.png`}
        alt=""
        aria-hidden
        width={size}
        height={size}
        style={{ display: "block" }}
      />
      {withWordmark && (
        <span
          className="text-foreground font-semibold tracking-[-0.015em]"
          style={{ fontSize: Math.round(size * 0.6) }}
        >
          ParcelPoint Ship
        </span>
      )}
    </span>
  );
}
